import React, { useState } from "react";
import axios from "axios";

export default function AadhaarAuth() {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("");
  const [pidData, setPidData] = useState("");
  const [error, setError] = useState("");

  const startAuth = async () => {
    try {
      setLoading(true);
      setError("");
      setStep("Discovering RD Service...");

      // 1️⃣ Discover
      await axios.get("https://mdk7v2f6-5000.inc1.devtunnels.ms/api/discover");

      setStep("Fetching Device Info...");
      await axios.get("https://mdk7v2f6-5000.inc1.devtunnels.ms/api/device-info");

      // 2️⃣ Capture Fingerprint
      setStep("Please place your finger on scanner...");

      const pidXml = `<?xml version="1.0"?>
<PidOptions ver="1.0">
  <Opts fCount="1" fType="0" format="0" pidVer="2.0" timeout="10000" env="P"/>
</PidOptions>`;

      const captureRes = await axios.post(
        "https://mdk7v2f6-5000.inc1.devtunnels.ms/api/capture",
        pidXml,
        { headers: { "Content-Type": "text/xml" } }
      );

      setPidData(captureRes.data);
      setStep("Authentication Successful ✅");

      // Auto close popup
      setTimeout(() => {
        setLoading(false);
        setStep("");
      }, 2000);

    } catch (err) {
      setLoading(false);
      setError("Fingerprint capture failed ❌");
    }
  };

  return (
    <div className="aadhaar-container">
      <h2>Aadhaar Biometric Authentication</h2>

      <button className="auth-btn" onClick={startAuth}>
        Start Aadhaar Authentication
      </button>

      {/* 🔥 Modal */}
      {loading && (
        <div className="modal">
          <div className="modal-box">
            <div className="loader"></div>
            <p>{step}</p>
          </div>
        </div>
      )}

      {error && <p className="error">{error}</p>}

      {pidData && (
        <textarea
          rows="6"
          value={pidData}
          readOnly
          placeholder="PID DATA"
        />
      )}
    </div>
  );
}
